export enum ValuationQualityIAZI {
    Good = 'Good',
    Fair = 'Fair',
    Extrapolated = 'Extrapolated',
    Prediction = 'Prediction'
}
